import { SEARCH_TRACKER_TRANSPORT_KEYWORD_LIST_ID } from "app/action_types/searchTracker_action_types";

interface ISearchTrackerReducer {
    keywordListId: string;
}

const defaultState: ISearchTrackerReducer = {
    keywordListId: "",
};

export function SearchTrackerReducer(
    state: ISearchTrackerReducer = defaultState,
    action: { type: string; keywordListId?: string },
) {
    switch (action.type) {
        case SEARCH_TRACKER_TRANSPORT_KEYWORD_LIST_ID: {
            return {
                ...state,
                keywordListId: action.keywordListId || "",
            };
        }
        default:
            return state;
    }
}
